module.exports = __webpack_public_path__ + "index.970606ac.scss";


//////////////////
// WEBPACK FOOTER
// ./src/screens/LoginBot/index.scss
// module id = 2605
// module chunks = 0